<template>
  <LayoutPage class="test-drive-simple-car-page" :title="pageTitle">
    <div class="sections-page" v-if="post">
      <component
          v-for="sec in changeOrdersSections"
          :key="sec.id"
          :is="`sec${sec.name}`"
          :section="sec"
          class="section"
      />
      <div class="section td-consolusion car-list" v-if="post && post.id && car && car.brands && car.brands.length">
        <div class="container-middle">
          <TableOtherModels :car="car" :id="post.id + ''"/>
        </div>
      </div>

      <div v-if="post && post.id" class="section td-consolusion">
        <div class="container-middle">
          <facebook-button>Deila</facebook-button>
        </div>
      </div>

      <div class="section td-consolusion" v-if="post && post.api == 1">
        <div class="container-middle blog-aca">
          <AmountCarsAvailable
              :propLogo="'https://uploads-ssl.webflow.com/5d7552387a6dfaca8c256678/5d7643b98b433514d3f6cdf7_bilablogg_logo.png'"
              :propBrand="'Bilablogg.is er samstafsaðili Bilaskra.is'"
              :propCompanyAddress="'Við reynsluökum bílum, tökum viðtöl, skrifum greinar og fjöllum um bíla á óhlutdrægan hátt. Umferð, öryggi, vegir, tryggingamál og allt annað sem tengist bílum og umferð.'"
              :propLinkHref="'https://www.bilablogg.is/'"
              :propLinkText="'www.bilablogg.is'"
              :loaded="true"
          />
        </div>
      </div>
      <secSimilarPosts class="section"/>
    </div>
    <!-- <div class="container-large" v-else>
      <h1 class="h2">Sorry, but page is empty...</h1>
    </div> -->
  </LayoutPage>
</template>

<script>
// import axios from 'axios'
import axios from "@/helpers/axios"
import {mapGetters, mapActions, mapState, mapMutations} from 'vuex'
import LayoutPage from '@/layout/blog'

import secBanner from '@/components/Blog/SimplePost/banner'
import secTable from '@/components/Blog/SimplePost/table'
import secSlider from '@/components/Blog/SimplePost/slider'
import secImage from '@/components/Blog/SimplePost/image'
import secVideo from '@/components/Blog/SimplePost/video'
import secContent from '@/components/Blog/SimplePost/content'
import secNotes from '@/components/Blog/SimplePost/notes'
import secConclusion from '@/components/Blog/SimplePost/conclusion'
import secSimilarPosts from '@/components/Blog/SimplePost/similar'

import TableOtherModels from '@/components/Dealers/TableOtherModels'
import AmountCarsAvailable from "@/components/Dealers/AmountCarsAvailable"

import FacebookButton from "@/components/FacebookButton"

export default {
  data: () => ({
    sections: [],
    existSections: true,
    car: null,
  }),
  components: {
    LayoutPage,
    secBanner,
    secTable,
    secSlider,
    secImage,
    secVideo,
    secContent,
    secNotes,
    secConclusion,
    secSimilarPosts,

    TableOtherModels,
    AmountCarsAvailable,
    FacebookButton
  },
  methods: {
    ...mapActions('blog', {
      // setDataPage: 'blog/SET_DATA_SIMPLE_PAGE',
      getDataPost: 'GET_DATA_POST'
    }),
    ...mapMutations({
      setData: 'SET_DATA'
    }),
    getCarInfo() {
      // const api = this.$store.state.api;
      axios.get(`/new-cars/get-car?id=${this.post.car_id}`)
          .then((res) => this.car = res.data)
          .catch((err) => console.log('err', err))
    },
    checkExistSections() {
      if (this.sectionsPage.length) return
      this.existSections = false
    }
  },
  computed: {
    ...mapState('blog', {
      post: state => state.simplePage
    }),
    ...mapGetters('blog', {
      mainDataPage: 'GET_MAIN_DATA_SIMPLE_PAGE',
      sectionsPage: 'GET_SECTIONS_SIMPLE_PAGE'
    }),
    isCar() {
      return this.post && this.post.car_id
    },
    filterSection() {
      return this.sections.filter(sec => sec.name != 'Similar')
    },
    changeOrdersSections() {
      const anotherApiSections = []
      let flag = false
      const sections = this.filterSection.filter(sec => {
        if (sec.name === "Banner") {
          flag = true
        } else {
          flag = false
        }

        if (flag) {
          return true
        } else {
          anotherApiSections.push(sec)
          return false
        }
      })
      return [...sections, ...anotherApiSections]
    },
    pageTitle() {
      return this.post.title || 'Bilaskra.is - Leitarvél nýrra bíla frá öllum umboðum';
    },
  },
  watch: {
    isCar: {
      immediate: true,
      handler() {
        if (!!this.isCar) {
          this.getCarInfo()
        }
      }
    },
    '$route.params.id': {
      immediate: true,
      handler() {
        this.getDataPost(this.$route.params.id)
      }
    },
    post: {
      immediate: true,
      deep: true,
      handler() {
        setTimeout(() => {
          window.scrollTo(0, 0)
        }, 300)
      }
    },
    sectionsPage: {
      handler() {
        this.checkExistSections()

        const category = this.mainDataPage && this.mainDataPage.categoryUrlName
        const arrPath = location.pathname.split('/')
        const some = arrPath.some(el => el == category.toLowerCase())
        return some
            ? this.sections = this.sectionsPage
            : ''
      }
    }
  },
  beforeDestroy() {
    this.setData({
      field: 'blog.simplePage',
      data: {}
    })
  }
}
</script>
